import React, { useState, useEffect } from "react";
import {
  AppBar, Avatar, Toolbar, Typography, IconButton, Badge, Box,
  Menu, MenuItem, Divider, Button, useMediaQuery
} from "@mui/material";
import { Folder } from "@mui/icons-material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import logo from '../Ecunive-logo.png';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import NotificationModal from "./NotificationModal";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./navbar.css?v=1.0";

const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [notificationTitle, setNotificationTitle] = useState("");
  const [notificationContent, setNotificationContent] = useState("");
  const [notifications, setNotifications] = useState([]);
  const { user, logout } = useAuth();
  const isSmallScreen = useMediaQuery('(max-width:600px)');

  const navigate = useNavigate();

  const handleOpenModal = (title, content) => {
    setNotificationTitle(title);
    notifications.isReaded = true;
    setNotificationContent(content);
    setAnchorEl(null);
    setOpenModal(true);
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await api.get(`/notifications/${user._id}`);
        setNotifications(response.data);
      } catch (error) {
        console.error('Erreur de chargement:', error);
      }
    };
    fetchNotifications();
  }, [user]);

  return (
    <AppBar position={isSmallScreen ? "fixed" : "sticky"} className="navbar" color="blue" backgroundColor="white">
      <Toolbar className="toolbar" >
        <Box component={Link} to={'/'} sx={{ display: "flex", alignItems: "center", gap: 2, marginTop: '9px' }}>
        <img src={logo} alt="Logo" />
        </Box>

        {(user?.type === 'student' && isSmallScreen) && (
           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
           <IconButton onClick={() => navigate(`/mes-documents/${user.id}`)}>
             <Folder />
           </IconButton>
           
         </Box>         
        )}

        {(user?.type === 'student' && isSmallScreen) && (
           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>

           <IconButton onClick={() => navigate(`/condidatures/${user.id}`)}>
             <AutoStoriesIcon />
           </IconButton>
           
         </Box>         
        )}

        {user? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
              <Badge badgeContent={notifications.length} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
            {(notifications.length == 0) && (
                <MenuItem>
                  Aucune nouvelle notification
                </MenuItem>
            )}
              
              {notifications.map((notif, index) => (
                <MenuItem key={index} onClick={() => handleOpenModal(notif.title, notif.content)}>
                  {notif.title}
                </MenuItem>
              ))}
            </Menu>
            
            <NotificationModal open={openModal} onClose={() => setOpenModal(false)} title={notificationTitle} content={notificationContent} />

            <IconButton onClick={(e) => setProfileMenuAnchor(e.currentTarget)}>
              <Avatar src={user.profilePicture} alt={user.name} />
              <ArrowDropDownIcon />
            </IconButton>

            <Menu anchorEl={profileMenuAnchor} open={Boolean(profileMenuAnchor)} onClose={() => setProfileMenuAnchor(null)}>
              <MenuItem disabled>{user.name}</MenuItem>
              <Divider />
              <MenuItem onClick={() => { logout(); setProfileMenuAnchor(null); navigate("/"); }}>Se déconnecter</MenuItem>
            </Menu>
          </Box>
        ) : (
          <Box sx={{ display: "flex", gap: 1 }}>
            
            <Button style={{backgroundColor: "#27eea0", color: "#fff"}} onClick={() => {navigate("/connexion")}} >connexion</Button>
            <Button style={{backgroundColor: "#27aae0", color: "#fff"}} onClick={() => {navigate("/inscription")}} >inscription</Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar
